export function SHOW_LOADER() {
  return {
    type: 'SHOW_LOADER',
  };
}

export function HIDE_LOADER() {
  return {
    type: 'HIDE_LOADER',
  };
}